import React, { useCallback, useContext } from 'react';
import { observer } from 'mobx-react';
import { BringgFontIcons } from '@bringg/bringg-icons';
import IconButton from '../../../components/icon-button/icon-button';
import { useStores } from '../../../recipes';
import { DismissConfirmContext } from '../dismiss-confirm';

interface Props {
	alertUuid: string;
	ownerId: number;
}

const ColumnActionCell = ({ alertUuid, ownerId }: Props) => {
	const {
		usersStore: { currentUser }
	} = useStores();

	const { setDismissModalVisible, setIdsToDismiss } = useContext(DismissConfirmContext);
	const onClick = useCallback(() => {
		setDismissModalVisible(true);
		setIdsToDismiss([alertUuid]);
	}, [setDismissModalVisible, setIdsToDismiss, alertUuid]);

	return !ownerId || currentUser.id === ownerId ? (
		<div className="row-actions-wrapper">
			<IconButton icon={BringgFontIcons.Trash} onClick={onClick} />
		</div>
	) : null;
};

export default observer(ColumnActionCell);
